import { REVIEW_TYPE, POSITIVE_REVIEW_TYPE } from './constants';

export function generateReview({
  current,
  time,
  cardId,
  cardAuthor,
  cardMessage,
}) {
  if (current) {
    return {
      ...current,
      type: REVIEW_TYPE.CUSTOM_REVIEW,
      recommendationType: POSITIVE_REVIEW_TYPE,
      updatedTime: time,
      reviewText: cardMessage,
      reviewer: {
        name: cardAuthor,
      },
    };
  }

  return {
    id: cardId,
    type: REVIEW_TYPE.CUSTOM_REVIEW,
    recommendationType: POSITIVE_REVIEW_TYPE,
    createdTime: time,
    reviewText: cardMessage,
    reviewer: {
      name: cardAuthor,
    },
  };
}

export function mapReviewToCard(review) {
  return {
    author: review.reviewer && review.reviewer.name,
    message: review.reviewText,
    time: review.createdTime,
  };
}
